// All page actions

import axios from 'axios';
import * as types from './actions';


//INIT CONTENTFUL API FOR FETCHING DATA
const API_BASE_URL = 'https://cdn.contentful.com';
const API_SPACE_ID = 'v0rjuhk1u9oa';
const API_KEY = '68d433918d1543c2c3f336ed3162bd8f2ecc11eb8a9f012a87244dfb7baa8a64';


// FETCH PAGES
export async function fetchPages() {
  const CONTENT_TYPE = 'section';

  return async (dispatch) => {
    axios.get(`${API_BASE_URL}/spaces/${API_SPACE_ID}/entries?access_token=${API_KEY}&content_type=${CONTENT_TYPE}`)
    .then( (pages) => {
      console.log("CONTENTFUL DATA LOADED BY ACTION");
      // pass data to reducer
      dispatch({
        type: types.FETCH_PAGES,
        payload: pages.data
      });
    })
    .catch( (err) => {
      dispatch({
        type: types.FETCH_PAGES_FAIL,
        payload: err
      });
    });
  }


}



// WEBPACK FOOTER //
// ./client/actions/page-actions.js